export default function(err, is_fov = false) {
  let errorMsg, debugMsg

  if (err.response) {
    const message = err.response.data.error_msg

    if (err.response.status === 504) {
      errorMsg = 'Took too long to process file, consider resizing.'
      debugMsg = 'Timeout error'
    } else if (message && message.match('You are not allowed')) {
      errorMsg = `This file type is not supported. Please use ${is_fov ? 'JPG, GIF, or PNG' : 'JPG, BMP, PNG, or PDF'} file types.`
    } else if (message && (message.includes('corrupted') || message.includes('Unrecoverable error') || message.includes('document may be damaged') || message.includes('not an image?'))) {
      errorMsg = 'Could not process file, file may be corrupted'
    } else {
      errorMsg = 'Something went wrong, please try again.'
    }
    debugMsg = debugMsg || err.response.data.error_msg
  } else if (err.request) {
    errorMsg = 'Could not connect, please try again.'
  } else {
    errorMsg = err.message && err.message.match(/timeout of/) ? 'Took too long to process file, consider resizing' : 'Something went wrong, please try again.'
  }

  return { errorMsg, debugMsg: debugMsg || err.message }
}



// WEBPACK FOOTER //
// ./src/helpers/getRequestError.js